module Client.Domain.MeasuredValueString

let temperatureToString = sprintf "%.2f °C"

let conductivityToString = sprintf "%d μS/cm"

let percentageToString = sprintf "%.2f %%"

let rainFallToString = sprintf " %.1f mm"

let windSpeedToString = sprintf "%.1f km/h"

let windDirectionToString = sprintf "%.1f °"

let phToString = sprintf "%.2f"

let distanceToHumanReadable (distanceInMilliMeters: int) : float * string =
    if distanceInMilliMeters > 1000 then 1000.0, "m"
    elif distanceInMilliMeters > 10 then 10.0, "cm"
    else 1.0, "mm"

let distanceToString (distanceInMilliMeter: int) =
    let factor, unit = distanceToHumanReadable distanceInMilliMeter

    sprintf "%.2f %s" (float distanceInMilliMeter / factor) unit

let liquidLevelToString (level: int) = distanceToString level

let solarRadiationToString = sprintf "%d W/m²"

let pressureToString = sprintf "%.1f Bar"